/* eslint-disable no-console */
<template>
  <div>
    <div class="card z-depth-5 p-3">
      <h4 class="text-center font-weight-bold py-3">All Students</h4>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead class="thead-dark">
            <tr>
              <th scope="col">Email</th>
              <th scope="col">First Name</th>
              <th scope="col">Last Name</th>
              <th scope="col">Birthday</th>
              <th scope="col">Grade</th>
              <th scope="col">City</th>
              <th scope="col">Guardian Name</th>
              <th scope="col">Guardian Email</th>
              <th scope="col">Guardian Phone</th>
              <th scope="col">Points</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="student in students" :key="student._id">
              <th>{{ student.email }}</th>
              <th>{{ student.first_name }}</th>
              <td>{{ student.last_name }}</td>
              <td>{{ student.birthday }}</td>
              <td>{{ student.grade }}</td>
              <td>{{ student.city }}</td>
              <td>{{ student.parent_first_name }} {{student.parent_last_name}}</td>
              <td>{{ student.parent_email }}</td>
              <td>{{ student.parent_phone_number }}</td>
              <td>{{ student.points }}</td>
            
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";


export default {
  name: "Students",
  components: {
  
  },
  data() {
    return {
      students: [],
      currentStudentId: "",
      fastAdminToken: localStorage.getItem("fastAdminToken"),
    };
  },
  methods: {
    getStudentId(student) {
      this.currentStudentId = student._id;
      this.teacher = student.teacher;
      
      for(let item of this.teachers) {
        if(item._id == this.teacher) {
          this.currentTeacherName = item.first_name;
          break;
        }
      }

      this.modalTeacher = true;
    },

    assignTeacher() {
      let data = {
        teacher: this.teacher,
        student: this.currentStudentId,
      };


      const config = {
        headers: {
          Authorization: "Bearer " + this.fastAdminToken,
          "Content-Type": "application/json",
        },
      };
      this.$toast.open({
        message: "Processing : Assigning Teacher To Student Please Wait...",
        type: "info",
      });
      axios
        .post(this.$apiURI + "/enrollment/assign/teacher", data, config)

        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            this.$toast.open({
              message: "Teacher Assigned Successfully",
              type: "success",
            });
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        });
    },
    activate(account_id) {
      const config = {
        headers: {
          Authorization: "Bearer " + this.fastAdminToken,
          "Content-Type": "application/json",
        },
      };
      this.$toast.open({
        message: "Processing : Activating Account Please Wait...",
        type: "info",
      });
      axios
        .post(this.$apiURI + "/account/" + account_id + "/activate", config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            this.$toast.open({
              message: "Account Activated Successfully",
              type: "success",
            });
            window.location.reload();
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        });
    },
    deactivate(account_id) {
      const config = {
        headers: {
          Authorization: "Bearer " + this.fastAdminToken,
          "Content-Type": "application/json",
        },
      };
      this.$toast.open({
        message: "Processing : Disabling Account Please Wait...",
        type: "info",
      });
      axios
        .post(this.$apiURI + "/account/" + account_id + "/deactivate", config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : " + response.data.message,
              type: "error",
            });
          } else {
            this.$toast.open({
              message: "Account Disabled Successfully",
              type: "success",
            });
            window.location.reload();
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: "Error : " + error.response.data.message,
            type: "error",
          });
        });
    },
  },
  mounted() {
    this.$toast.open({
      message: "Processing : Loading Students Data Please Wait...",
      type: "info",
    });

    const config = {
      headers: {
        Authorization: "Bearer " + this.fastAdminToken,
        "Content-Type": "application/json",
      },
    };
    axios
      .get(this.$apiURI + "/account/students", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          this.students = response.data.data.students;
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });

    axios
      .get(this.$apiURI + "/account/teachers", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          this.teachers = response.data.data.teachers;
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });
  },
};
</script>
